/**
 * Quita un punto final del título (p. ej. "Programa: tagline." → "Programa: tagline").
 */
export function stripTrailingPeriod(text) {
  if (text == null || typeof text !== 'string') return text;
  return text.replace(/\.\s*$/, '').trimEnd();
}

export default stripTrailingPeriod;
